module.exports = __webpack_public_path__ + "system/static/img/code.418b1885.jpg";